/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccessRequestsAppAccessRulePatchRequest
 */
export interface AccessRequestsAppAccessRulePatchRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRulePatchRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRulePatchRequest
     */
    app_url?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessRequestsAppAccessRulePatchRequest
     */
    identifier_from_source?: string;
}

/**
 * Check if a given object implements the AccessRequestsAppAccessRulePatchRequest interface.
 */
export function instanceOfAccessRequestsAppAccessRulePatchRequest(value: object): value is AccessRequestsAppAccessRulePatchRequest {
    return true;
}

export function AccessRequestsAppAccessRulePatchRequestFromJSON(json: any): AccessRequestsAppAccessRulePatchRequest {
    return AccessRequestsAppAccessRulePatchRequestFromJSONTyped(json, false);
}

export function AccessRequestsAppAccessRulePatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestsAppAccessRulePatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'app_url': json['app_url'] == null ? undefined : json['app_url'],
        'identifier_from_source': json['identifier_from_source'] == null ? undefined : json['identifier_from_source'],
    };
}

export function AccessRequestsAppAccessRulePatchRequestToJSON(json: any): AccessRequestsAppAccessRulePatchRequest {
    return AccessRequestsAppAccessRulePatchRequestToJSONTyped(json, false);
}

export function AccessRequestsAppAccessRulePatchRequestToJSONTyped(value?: AccessRequestsAppAccessRulePatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'app_url': value['app_url'],
        'identifier_from_source': value['identifier_from_source'],
    };
}

